import "@fontsource-variable/inter/index.css";
import "./index.css";
import type { PublicClientApplication } from "@azure/msal-browser";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import type { AuthStatus } from "@/auth/auth-status";
import { initMsal } from "@/auth/msal";
import { getAuthConfig } from "@/lib/env";
import { reloadForNewBuild } from "@/lib/stale-build";
import { App } from "./App";

// A screen's code failed to load because Pulse was redeployed since this tab opened: reload onto the new build.
window.addEventListener("vite:preloadError", (event) => {
  if (reloadForNewBuild()) event.preventDefault();
});

async function bootstrap() {
  const config = getAuthConfig();
  let msal: PublicClientApplication | null = null;
  let authStatus: AuthStatus;

  if (!config.ok) {
    authStatus = { state: "unconfigured", missing: config.missing };
  } else {
    try {
      msal = await initMsal(config.config);
      authStatus = { state: "ready" };
    } catch (error) {
      console.error("MSAL initialisation failed", error);
      authStatus = {
        state: "unconfigured",
        missing: [],
        error: `Sign-in could not start: ${error instanceof Error ? error.message : String(error)}`,
      };
    }
  }

  const root = document.getElementById("root");
  if (!root) throw new Error("#root element missing from index.html");
  createRoot(root).render(
    <StrictMode>
      <App msal={msal} authStatus={authStatus} />
    </StrictMode>,
  );
}

void bootstrap();
